module.exports = __webpack_public_path__ + "img/afjk@2x.378b9e78.png";